import { css, jsx } from '@emotion/core';
import { Pagination as AntPagination } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '@/styles/utilities';

const style = {
  wrapper: css`
    display: flex;
    align-items: baseline;
  `,
  resultsText: css`
    margin-right: 12px;
    font-weight: bold;
    color: ${colors.secondaryGrey};
    font-family: 'Lato', sans-serif;
    font-size: 1.2rem;
  `,
};

const Pagination = props => {
  const { total } = props;

  return (
    <div css={style.wrapper}>
      <p css={style.resultsText}>
        {total || 'No'} Result{total !== 1 ? 's' : ''}
      </p>
      <AntPagination {...props} />
    </div>
  );
};

Pagination.propTypes = {
  total: PropTypes.number,
};

Pagination.defaultProps = {
  total: 0,
};

Pagination.defaultProps = {};

export default Pagination;
